<h5 *ngIf="sectionTitle && !hideTitle" class="mt-3">{{ sectionTitle }}</h5>
<div class="d-flex flex-wrap">
  <div
    class="relative d-flex full-width flex-wrap"
    *ngFor="let a of amendments"
    [ngClass]="{
      'border-amd': a.number > 0 && a == amendments.at(-1),
      'border-amd-old': a.number > 0 && a != amendments.at(-1),
      'flex-column': isFullWidthSection,
    }"
  >
    <span
      [ngClass]="{
        'amendment-title': a == amendments.at(-1),
        'amendment-title-old': a != amendments.at(-1),
      }"
      *ngIf="a.number > 0"
      >Amendment {{ a.number }}<span
        *ngIf="a.isMinor"
        class="minor-amendment-indicator"
        title="Minor Amendment"
        >Minor</span
      ></span
    >
    <div
      *ngFor="let step of a.steps"
      [matTooltip]="step.name"
      [ngClass]="{
        'flex-auto': hasVisibleSignatures(step),
        'full-width': step.fullWidth,
      }"
    >
      <div
        class="step-wrapper d-flex relative full-height"
        [ngClass]="{
          'flex-column': isFullWidthSection,
          'active-step': step.active && !disabled,
        }"
      >
        <div
          *ngFor="let s of step.signatures"
          class="signature"
          [ngClass]="{ invisible: !s.visible }"
        >
          <master-control
            [s]="s"
            [type]="s.type"
            [visible]="s.visible"
            [roleIds]="s.roles"
            [roleCodes]="s.roleCodes"
            [userNames]="s.userNames"
            [approvedBy]="s.approvedBy"
            [checkbox_checked]="s.value"
            [header]="s.name"
            [title]="s.name"
            [question]="s.question"
            [disabled]="s.disabled"
            [radioOptions]="s.options"
            [approved]="s.approved"
            [showApprove]="s.approveAction"
            [showUnapprove]="s.unapproveAction"
            [showDisapprove]="s.disapproveAction"
            [showCancel]="s.cancel"
            [cancelID]="s.cancelID"
            [approvedOn]="s.approvedOn"
            [taskId]="s.taskId"
            [enabled]="s.enabled"
            [color]="'primary'"
            [questionDisabled]="s.checkboxDisabled"
            [label]="s.name"
            [text]="s.question"
            [radioQuestion]="s.question2"
            [radioSelection]="s.value2"
            [textBefore]="s.question"
            [textAfter]="s.question2"
            [textAfter2]="s.question3"
            [textValue]="s.textValue"
            [checkboxVisible]="s.visible ?? false"
            [disableEdit]="s.disableEdit"
            [warning]="s.warning ?? false"
            [moreInfo]="s.moreInfo"
            [scheduleResourceId]="s.scheduleResourceId"
            [dateValue1]="s.dateValue1"
            [dateValue2]="s.dateValue2"
            [dateValue3]="s.dateValue3"
            [scheduleName]="s.scheduleName"
            [locationName]="s.locationName"
            [configuration]="s.configuration"
            [formType]="formType"
            [formId]="form?.id"
            [status]="s.status"
            [sectionNumber]="sectionNumber"
            [hilite]="s.hilite"
            [serialNo]="'serialNo'"
            [followUpChanged]="s.followUpChanged"
            [privilegeToApproveAnswer]="s.privilegeToApproveChanges"
            [privilegeWoApproval]="privilegeWoApproval"
            [answerChangedById]="s.answerChangedById"
            [answerChangedBy]="s.answerChangedBy"
            [showTestApprove]="showTestApproveFor(s)"
            (approve)="sign(s, action.Approve, $event)"
            (checked)="check($event, s)"
            (changed)="changed($event, s)"
            (unapprove)="sign(s, action.Unapprove, $event)"
            (disapprove)="sign(s, action.Disapprove, $event)"
            (approveAnswer)="changed($event, s, action.Approve)"
            (disapproveAnswer)="changed($event, s, action.Disapprove)"
            (testApprove)="testApprove(s)"
            (close)="close(s)"
          >
          </master-control>
        </div>
      </div>
    </div>
  </div>
</div>
